// @flow
/* eslint sort-keys: "error"*/

import type {SystemData} from '../../server/utils/systemData';

export type State = SystemData;
export type SiteFeatures = $PropertyType<SystemData, 'siteFeatures'>;

const initialState = {
    brand: 'homeaway_us',
    brandId: '',
    consolidationBanner: '',
    currency: 'USD',
    directEntry: false,
    domainName: '',
    environment: 'development',
    facebook: {admins: '', appId: '', locale: 'en_US_HA'},
    fullLocale: '',
    gtsQuery: false,
    hasSortLegalDisclaimer: false,
    havId: '',
    hostname: '',
    isDesktop: false,
    isGoodBot: false,
    isInternalUser: false,
    isMetric: false,
    isMobile: false,
    isTablet: false,
    locale: 'en-US',
    mockResponse: '',
    referer: '',
    siteFeatures: {
        hasMetricAreaUnit: false,
        hasSortLegalDisclaimer: false,
        showTotal: false
    },
    siteName: '',
    theme: 'gt',
    transitionBanner: ''
};

const identity = (state: State = initialState) => state;

export default identity;
